module.exports = __webpack_public_path__ + "media/KikiT.54d91b9c.mp3";